import { render, staticRenderFns } from "./moreAnnoucement.vue?vue&type=template&id=00a1037c&"
import script from "@viewJs/home/moreAnnoucement.js?vue&type=script&lang=js&"
export * from "@viewJs/home/moreAnnoucement.js?vue&type=script&lang=js&"
import style0 from "./moreAnnoucement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports